export default "__VITE_ASSET__DhZcY9sO__"